import CtaBarButton from '../base/cta-bar-button';
import { useState } from 'react';
import FacilityModal from '../modal/FacilityModal';
import {
  brandColor,
  getClassTextForColor,
  getEditorColor,
  renderColor,
} from '../../util/ColorUtil';
import { Constants } from '../../util/Constants';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import ConditionalWrapper from '../ConditionalWrapper';
import {useRouter} from "next/router";

const ContentImageLeft = ({ data, global, lang }) => {
  const isConditional =
    data?.field_make_this_block_conditiona?.[0]?.value == 1 ? true : false;
  const filterDataLayer = data?.field_filter_data_layer;
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_title_color),
    isItUndefined(data?.field_subtitle_color)
  ).filter((x) => x)[0];
  const { locale } = useRouter();

  const returnContent = (padding) => {
    return (
      <div
        className={'helper-padding'}
        style={{
          paddingLeft: padding,
        }}
      >
        {data?.field_title_color[0]?.value && (
          <h2
            className={`${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(modifyLinks(data?.field_title_color[0]?.value, locale)),
            }}
          />
        )}
        {
          data?.field_subtitle_color[0]?.value && (
            <span
              className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: modifyLinks(data?.field_subtitle_color[0]?.value, locale),
              }}
            />
          ) //cleanHTML is removed, because we need &nbsp here
        }
        {data.field_cta_bar_button_selection.length > 0 && (
          <CtaBarButton
            blockTypeClass={'content-image-left'}
            bgColor={renderColor(
              getEditorColor(brandColor(data?.field_background_color[0]?.value))
            )}
            data={data.field_cta_bar_button_selection[0].cta_bar_button}
            setMarketoTrigger={setMarketoTrigger}
            pathname={true}
          />
        )}
      </div>
    );
  };

  return (
    <ConditionalWrapper
      isConditional={isConditional}
      filterDataLayer={filterDataLayer}
      blockName={'Content Image Left Block Type'}
    >
      <div
        className={
          'content-image-left ' +
          getClassTextForColor(data?.field_background_color[0]?.value)
        }
        style={{
          backgroundColor: brandColor(data?.field_background_color[0]?.value),
          paddingTop: data?.field_remove_top_padding
            ? data?.field_remove_top_padding[0]?.value === '1'
              ? '0'
              : ''
            : '',
        }}
      >
        {(data?.field_full_span.length === 0 ||
          data?.field_full_span[0].value === '0') && (
          <img
            alt={'image'}
            src={`${Constants.cloudinaryImage}${data?.field_image[0]}`}
          />
        )}
        {data?.field_full_span.length === 0 ||
        data?.field_full_span[0].value === '0' ? (
          <div className={'helper-right-margin-container'}>
            {returnContent()}
          </div>
        ) : (
          <div className={'inner-container'}>
            {data.field_full_span.length === 1 && (
              <img
                alt={'image'}
                src={`${Constants.cloudinaryImage}${data?.field_image[0]}`}
              />
            )}
            {returnContent()}
          </div>
        )}
        {marketoTrigger && (
          <FacilityModal
            lang={lang}
            global={global}
            setTrigger={setMarketoTrigger}
            trigger={marketoTrigger}
          >
            {
              data?.field_cta_bar_button_selection[0]?.cta_bar_button
                ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
            }
          </FacilityModal>
        )}
      </div>
    </ConditionalWrapper>
  );
};

export default ContentImageLeft;
